export default "__VITE_ASSET__Db77_QRX__"